import React, { FC } from 'react';
import { RatingRow, RatingValueInline } from './Rating';

export interface MatrixRow {
    key: string;
    label: string;
    value: number | null;
    onChange: (value: number) => void;
    children?: MatrixRow[];
}

interface Props {
    rows: MatrixRow[];
    readOnly?: boolean;
}

const ROW = 'flex items-center justify-between gap-3 px-4 max-[560px]:flex-col max-[560px]:items-start max-[560px]:gap-2';

export const EntityMatrix: FC<Props> = ({ rows, readOnly }) => (
    <div className="border border-border-token rounded-xl overflow-hidden">
        {rows.map((row) => (
            <div
                key={row.key}
                className="border-b border-border-token last:border-b-0"
            >
                <div className={`${ROW} py-2.5 bg-[#FAFAF8] dark:bg-surface-2`}>
                    <span className="text-[13.5px] font-bold text-text-1">
                        {row.label}
                    </span>
                    {readOnly ? (
                        <RatingValueInline value={row.value} />
                    ) : (
                        <RatingRow value={row.value} onChange={row.onChange} />
                    )}
                </div>
                {(row.children || []).map((child) => (
                    <div key={child.key} className={`${ROW} pt-2 pb-3`}>
                        <span className="text-[13.5px] font-medium text-text-2 pl-[14px] relative break-words before:content-[''] before:absolute before:left-[2px] before:top-1/2 before:w-[7px] before:h-[1.5px] before:bg-[#D5D0C8] dark:before:bg-track">
                            {child.label}
                        </span>
                        {readOnly ? (
                            <RatingValueInline value={child.value} />
                        ) : (
                            <RatingRow value={child.value} onChange={child.onChange} />
                        )}
                    </div>
                ))}
            </div>
        ))}
    </div>
);
